import { Box, Button, Grid, TextField } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../../App";
import EstoqueBRF from "../../components/classes/EstoqueBRF";
import AutocompleteCentroEstoque from "../../components/common/AutocompleteCentroEstoque";
import AutocompleteSKUEstoque from "../../components/common/AutocompleteSkuEstoque";
import EstoqueBRFDataset from "../../components/data/EstoqueBRFDataset";

import { useTranslation } from "react-i18next";

export default function NovoEstoqueEmbalagensFragment(props: any) {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(true);

  const [id, setId] = useState<string>("");
  const [centro, setCentro] = useState<string>("");
  const [material, setMaterial] = useState<string>("");
  const [quantidade, setQuantidade] = useState<string>("");
  const [quantidadeParceiro, setQuantidadeParceiro] = useState<string>("");
  const [unidadeMedida, setUnidadeMedida] = useState<string>("");

  const [quantidadeFieldValidation, setQuantidadeFieldValidation] = useState<{
    hasError: boolean;
    errorMessage: string;
  }>({
    hasError: false,
    errorMessage: "",
  });

  const [unidadeMedidaFieldValidation, setUnidadeMedidaFieldValidation] =
    useState<{
      hasError: boolean;
      errorMessage: string;
    }>({
      hasError: false,
      errorMessage: "",
    });

  const estoqueEmbalagensDataset: EstoqueBRFDataset = new EstoqueBRFDataset();

  useEffect(() => {
    if (props.estoqueBRF) {
      setId(props.estoqueBRF.id);
      setCentro(props.estoqueBRF.centro);
      setMaterial(props.estoqueBRF.material);
      setQuantidade(
        props.estoqueBRF.quantidade.slice(
          0,
          props.estoqueBRF.unidadeMedida.length * -1
        )
      );
      setUnidadeMedida(props.estoqueBRF.unidadeMedida);
      setIsUpdate(true);
    }
  }, []);

  function validate(): boolean {
    let isValid: boolean = true;

    if (!centro || centro.length < 1) {
      isValid = false;
    }

    if (!material || material.length < 1) {
      isValid = false;
    }

    if (!quantidade || quantidade.toString().length < 1) {
      isValid = false;
      setQuantidadeFieldValidation({
        hasError: true,
        errorMessage: t("pages.stockPartnerBrf.text.thisFieldCannotBeEmpty"),
      });
    } else {
      if (!/^-?\d+$/.test(quantidade)) {
        isValid = false;
        setQuantidadeFieldValidation({
          hasError: true,
          errorMessage: t("pages.stockPartnerBrf.text.thisFieldCanOnlyContainNumbers"),
        });
      } else {
        setQuantidadeFieldValidation({
          hasError: false,
          errorMessage: "",
        });
      }
    }

    if (!unidadeMedida || unidadeMedida.length < 1) {
      isValid = false;
      setUnidadeMedidaFieldValidation({
        hasError: true,
        errorMessage: t("pages.stockPartnerBrf.text.thisFieldCannotBeEmpty"),
      });
    } else {
      if (unidadeMedida.length > 5) {
        isValid = false;
        setUnidadeMedidaFieldValidation({
          hasError: true,
          errorMessage: t("pages.stockPartnerBrf.text.thisFieldCannotBeLonger"),
        });
      } else {
        setUnidadeMedidaFieldValidation({
          hasError: false,
          errorMessage: "",
        });
      }
    }

    if (!isValid) {
      setHasError(true);
    } else {
      setHasError(false);
    }

    return isValid;
  }

  function onSubmitHandler() {
    if (validate()) {
      if (isUpdate) {
        const estoqueEmbalagem: EstoqueBRF = new EstoqueBRF(
          parseInt(id),
          centro,
          material,
          parseInt(quantidade),
          parseInt(quantidadeParceiro),
          unidadeMedida
        );
        estoqueEmbalagensDataset.update(estoqueEmbalagem).then((e) => {
          props.onSubmit();
        });
      } else {
        const estoqueEmbalagem: EstoqueBRF = new EstoqueBRF(
          0,
          centro,
          material,
          parseInt(quantidade),
          parseInt(quantidadeParceiro),
          unidadeMedida
        );
        estoqueEmbalagensDataset.add(estoqueEmbalagem).then((e) => {
          props.onSubmit();
        });
      }
    }
  }

  return (
    <div>
      <div>
        <Box
          margin={"12px"}
          padding={"24px"}
          sx={{
            display: "flex",
            width: "100%",
            "align-items": "center",
          }}
        >
          <Box width={240} margin={"12px"}>
            <AutocompleteCentroEstoque
              value={props.estoqueBRF?.centro.toString()}
              onChange={(centro: any) => {
                setCentro(centro);
                validate();
              }}
            />
          </Box>

          <Box width={240} margin={"12px"}>
            <AutocompleteSKUEstoque
              value={props.estoqueBRF?.material.toString()}
              onChange={(sku: any) => {
                setMaterial(sku);
                validate();
              }}
            />
          </Box>

          <Box width={240} margin={"12px"}>
            <TextField
              required
              error={quantidadeFieldValidation.hasError}
              helperText={quantidadeFieldValidation.errorMessage}
              label={t("common.quantity")}
              variant="outlined"
              value={quantidade}
              onChange={(e) => setQuantidade(e.target.value)}
              onBlur={(e) => {
                validate();
              }}
            />
          </Box>

          <Box width={240} margin={"12px"}>
            <TextField
              required
              error={unidadeMedidaFieldValidation.hasError}
              helperText={unidadeMedidaFieldValidation.errorMessage}
              label={t("common.measurementUnit")}
              variant="outlined"
              value={unidadeMedida}
              onChange={(e) => setUnidadeMedida(e.target.value)}
              onBlur={(e) => {
                validate();
              }}
            />
          </Box>

          <Box>
            {isUpdate ? (
              <Button
                disabled={hasError || user.isSuporte}
                type="submit"
                variant="outlined"
                color="success"
                onClick={onSubmitHandler}
              >
                {t("common.save")}
              </Button>
            ) : (
              <Button
                disabled={hasError || user.isSuporte}
                type="submit"
                variant="outlined"
                color="success"
                onClick={onSubmitHandler}
              >
                {t("common.add")}
              </Button>
            )}
          </Box>
        </Box>
      </div>
    </div>
  );
}
